import React from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import { CircleCheckBig } from "lucide-react";

const ConnectedStatus: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-end connected-anchor-element">
      <div className="w-[46px] h-[46px] flex items-center justify-center rounded-lg">
        <CircleCheckBig className="w-6 h-6 text-green-500" />
      </div>
      <Tooltip anchorSelect=".connected-anchor-element" content={t("Connected")} />
    </div>
  );
};

export default ConnectedStatus;
